import { Component, OnInit } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import Swal from 'sweetalert2';
import * as fileSaver from 'file-saver';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css'],
})
export class ReportesComponent implements OnInit {
  // ? NgModel ¿para almacenar? la opción elegida.
  selectedReporte;
  selectedExtensionReporte;

  // *
  fechaInicio;
  fechaFin;

  // * Arreglo de reportes.
  reportes = ['Fecha', 'Fecha detallado', 'Productos', 'Facturas'];

  // * Arreglo de tipo de reportes.
  tipoReportes = [
    // 'pdf',
    'xlsx',
  ];

  // * ids Local Storage
  userIdLS = localStorage.getItem('userId');
  userRoleIdLS = localStorage.getItem('userRoleId');
  userEmpresaId = localStorage.getItem('idEmpresa');

  constructor(
    private router: Router,
    private reporteService: ReportesService
  ) {}

  ngOnInit(): void {
    if (this.userEmpresaId === '') {
      this.router.navigate(['/empresas']);
    } else if (this.userIdLS != null) {
      console.log('idempresa: ', this.userEmpresaId);
    } else {
      // reedirigir a login
      this.router.navigate(['/login']);
    }
  }

  resetTipoReporte = (value): any => {
    this.reportes.forEach((reporte) => {
      if (value === reporte) {
        this.selectedExtensionReporte = '';
        this.fechaInicio = '';
        this.fechaFin = '';
      }
    });
  };

  reporteFactura(): any {
    this.reporteService
      .generarReporteFactura(
        this.fechaInicio,
        this.fechaFin,
        this.selectedExtensionReporte
      )
      .subscribe((res) => {
        console.log('res.msgLog :>> ', res);
        if (res.msg === 'Sin resultados.') {
          this.swalError(res.msg);
        } else {
          Swal.fire({
            title: 'Descarga el reporte generado',
            allowEscapeKey: false,
            allowEnterKey: false,
            allowOutsideClick: false,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `Descargar`,
            returnInputValueOnDeny: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.reporteService.downloadReporteFecha().subscribe(
                (response) => {
                  const blob = new Blob([response], {
                    type:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
                  });
                  fileSaver.saveAs(blob, 'reporte.xlsx');
                  Swal.fire('¡Descargado!', '', 'success');
                },
                (err) => {
                  if (err) {
                    this.swalError('Error al descargar.');
                  }
                }
              );
            }
          });
        }
        
      });
  }

  reporteFechaXLSX = (): any => {
    this.reporteService
      .generarReporteFecha(
        this.fechaInicio,
        this.fechaFin,
        this.selectedExtensionReporte
      )
      .subscribe((res) => {
        if (res.msg === 'Sin resultados.') {
          this.swalError(res.msg);
        } else {
          Swal.fire({
            title: 'Descarga el reporte generado',
            allowEscapeKey: false,
            allowEnterKey: false,
            allowOutsideClick: false,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `Descargar`,
            returnInputValueOnDeny: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.reporteService.downloadReporteFecha().subscribe(
                (response) => {
                  const blob = new Blob([response], {
                    type:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
                  });
                  fileSaver.saveAs(blob, 'reporte.xlsx');
                  Swal.fire('¡Descargado!', '', 'success');
                },
                (err) => {
                  if (err) {
                    this.swalError('Error al descargar.');
                  }
                }
              );
            }
          });
        }
      });
  };

  reporteFechaDetallado = (): any => {
    this.reporteService
      .generarReporteFechaDetalle(
        this.fechaInicio,
        this.fechaFin,
        this.selectedExtensionReporte
      )
      .subscribe((res) => {
        if (res.msg === 'Sin resultados.') {
          this.swalError(res.msg);
        } else {
          Swal.fire({
            title: 'Descarga el reporte generado',
            allowEscapeKey: false,
            allowEnterKey: false,
            allowOutsideClick: false,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `Descargar`,
            returnInputValueOnDeny: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.reporteService.downloadReporteFecha().subscribe(
                (response) => {
                  const blob = new Blob([response], {
                    type:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
                  });
                  fileSaver.saveAs(blob, 'reporte.xlsx');
                  Swal.fire('¡Descargado!', '', 'success');
                },
                (err) => {
                  if (err) {
                    this.swalError('Error al descargar.');
                  }
                }
              );
            }
          });
        }
       
      });
  };

  reporteProducto = (): any => {
    this.reporteService
      .generarReporteProducto(
        this.fechaInicio,
        this.fechaFin,
        this.selectedExtensionReporte
      )
      .subscribe((res) => {
        if (res.msg === 'Sin resultados.') {
          this.swalError(res.msg);
        } else {
          Swal.fire({
            title: 'Descarga el reporte generado',
            allowEscapeKey: false,
            allowEnterKey: false,
            allowOutsideClick: false,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `Descargar`,
            returnInputValueOnDeny: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.reporteService.downloadReporteFecha().subscribe(
                (response) => {
                  const blob = new Blob([response], {
                    type:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
                  });
                  fileSaver.saveAs(blob, 'reporte.xlsx');
                  Swal.fire('¡Descargado!', '', 'success');
                },
                (err) => {
                  if (err) {
                    this.swalError('Error al descargar.');
                  }
                }
              );
            }
          });
        }
      });
  };

  downloadReporte = (): any => {
    const fechaInicioTD = Date.parse(this.fechaInicio);
    const fechaFinTD = Date.parse(this.fechaFin);

    if (this.selectedReporte == null && this.selectedExtensionReporte == null) {
      this.swalError('Debes seleccionar el tipo de reporte y extensión');
    }
    if (this.selectedReporte == null) {
      this.swalError('Debes seleccionar el tipo de reporte');
    }
    if (
      this.fechaInicio == '' ||
      this.fechaFin == '' ||
      (this.fechaInicio == '' && this.fechaFin == '')
    ) {
      this.swalError('Debes seleccionar las fechas');
    }
    if (this.selectedExtensionReporte == null) {
      this.swalError('Debes seleccionar el tipo de extensión del reporte');
    }

    if (fechaInicioTD <= fechaFinTD) {
      switch (this.selectedReporte) {
        case 'Fecha':
          if (this.selectedExtensionReporte == 'xlsx') {
            this.reporteFechaXLSX();
          } else if (this.selectedExtensionReporte == 'pdf') {
            this.swalError('Estamos trabajando en ello.');
          }
          break;
        case 'Fecha detallado':
          if (this.selectedExtensionReporte == 'xlsx') {
            this.reporteFechaDetallado();
          } else if (this.selectedExtensionReporte == 'pdf') {
            this.swalError('Estamos trabajando en ello.');
          }
          break;
        case 'Productos':
          if (this.selectedExtensionReporte == 'xlsx') {
            this.reporteProducto();
          } else if (this.selectedExtensionReporte == 'pdf') {
            this.swalError('Estamos trabajando en ello.');
          }
          break;
        case 'Facturas':
          if (this.selectedExtensionReporte == 'xlsx') {
            this.reporteFactura();
          } else if (this.selectedExtensionReporte == 'pdf') {
            this.swalError('Estamos trabajando en ello.');
          }
          break;
      }
    } else {
      this.swalError('Parámetros de fecha no válidos, intente nuevamente');
    }
  };

  swalError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      returnInputValueOnDeny: false,
    });
  };
}
